export var UserRole;
(function (UserRole) {
    UserRole["SUPER_ADMIN"] = "superadmin";
    UserRole["ADMIN"] = "admin";
    UserRole["STAFF"] = "staff";
    UserRole["NONE"] = "none";
})(UserRole || (UserRole = {}));
//# sourceMappingURL=cms-user.js.map